module.exports = __webpack_public_path__ + "img/Frame2241@2x.b7426610.png";